<template>
    <div class="hand hand_link"
         :class="{'anit-right': anitRight}"
         v-if="show">
        <div class="ksp-jf" v-if="finish">
            <span class="wcjf">已获得抽奖机会</span>
        </div>
        <img src="https://my-statics-cdn.app.xinhuanet.com/uploadfile/h5activity/img/20240204/hand.gif" alt="" />
        <div class="progress alert round">
            <span class="meter bar" :style="{width: `${proBar}px`}"></span>
        </div>
        <p class="hand-tips">
            <span v-if="finish">任务完成</span>
            <span v-else>浏览15秒得抽奖机会</span>
        </p>
    </div>
</template>

<script>
import client from '@/configs/client.js'

export default {
    data () {
        return {
            show: false,
            finish: false,
            anitRight: false,
            getMyTaskUrl: '/vote/prize/getMyTask',
            completeTaskUrl: '/vote/prize/task/reach',
            proBar: 0,
            timeout:null,
            interval:null,
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        reqHeader () {
            return {
                'device-token': 'draw2024-h5',
            }
        },
        // 初始化
        init () {
            // 如果是客户端中且是2024春节抽奖跳转过来的，那么判断任务
            if (client.xinhua && this.$route.query.from === 'draw2024h5') {
                this.$httpClient.post(this.getMyTaskUrl, {
                    type: 2
                }, {headers: this.reqHeader()}).then(res => {
                    if (res.data.code === 200) {
                        //1是任务未完成
                        if (res.data.data === 1) {
                            this.renderHand()
                        }
                    }
                })
            }
        },
        renderHand () {
            this.show = true
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            if (this.interval) {
                clearInterval(this.interval)
            }
            this.interval = setInterval(() => {
                this.proBar += 4
                if (this.proBar >= 60) {
                    clearInterval(this.interval)
                }
            }, 1000)
            this.timeout = setTimeout(() => {
                this.$httpClient.post(this.completeTaskUrl, {
                    type: 2
                }, {headers: this.reqHeader()}).then(res => {
                    if (res.data.code === 200) {
                        this.finish = true
                        setTimeout(() => {
                            this.anitRight = true
                            setTimeout(() => {
                                this.show = false
                            }, 300)
                        }, 2000)
                    }
                })
            }, 15 * 1000)
        }
    }
}
</script>

<style scoped>
.progress {
    width: 60px;
    border-radius: 5px;
    background-color: #f5f5f5;
    border: 1px solid #ffdcbe;
    margin: auto;
}

.hand_link {
    width: 122px;
    position: fixed;
    right: 4px;
    bottom: 17%;
    text-align: center;
    z-index: 999;
}

.hand_link img {
    width: 48px;
    height: 48px;
}

.bar {
    background: linear-gradient(270deg, #ffa144 0%, #ffc438 100%);
    border-radius: 5px;
    display: block;
    height: 7px;
    width: 0;
}

.wcjf {
    font-size: 10px;
    font-weight: 400;
    color: #f7b500;
    line-height: 14px;
    display: block;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 4px 8px;
    margin-bottom: 2px;
    border-radius: 9px;
    transform: translateZ(-1px);
}

p {
    font-size: 10px;
    font-weight: 400;
    color: #343a41;
    line-height: 14px;
}

.anit-right {
    animation: anit_right 0.3s;
    -webkit-animation: anit_right 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    animation-iteration-count: 1;
    /*动画只执行一次*/
    -moz-animation-iteration-count: 1;
    -webkit-animation-iteration-count: 1;
    -o-animation-iteration-count: 1;
}

@-webkit-keyframes anit_right {
    0% {
        transform: translate(0.4rem, 0);
    }

    100% {
        transform: translate(10rem, 0);
        display: none;
    }
}

@keyframes anit_right {
    0% {
        transform: translate(0.4rem, 0);
    }

    100% {
        transform: translate(6rem, 0);
        display: none;
    }
}

.ksp-jf {
    display: inline-block;
    position: relative;
    top:0;
    /* right: 20px;
    bottom: 26%; */
    text-align: center;
    z-index: 999;
}

.wcjf {
    font-size: 10px;
    font-weight: 400;
    color: #f7b500;
    line-height: 14px;
    display: block;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 4px 8px;
    margin-bottom: 2px;
    border-radius: 9px;
}
</style>